import React, { Component } from "react";
import "./Farming.css";
import farmImage from "../../images/pexels-enginakyurt-1435904.jpg"; // replace with your farm photo
class Farming extends Component {
    render(){
        return(
            <>
            <div className="farming-hero">
                <img src={farmImage} alt="farm field" className="farming-image"/>
                <div className="farming-overlay">
                    <h1>Fresh From Our Farm</h1>
                    <p>Wholesome, fresh, organic, and locally grown products — right from our hands to your table.</p>
                </div>
            </div>

            
            <div className="farming-content">
                <h2>What We Offer</h2>
                <ul>
                    <li><strong>Fresh Chicken & Duck Eggs</strong> – Collected daily for top quality.</li>
                    <li><strong>Seasonal Fruits & Vegetables</strong> – Grown naturally, always fresh.</li>
                    <li><strong>Exotic & Local Plants</strong> – Unique varieties for your garden or home.</li>
                    <li><strong>Fresh Plant Based Goods</strong> – Freshly made products from our harvest, crafted with care and seasonal flavors.</li>
                </ul>

                <p className="farming-note">
                    Please reach out with any questions or inquiries about availability, pickup, or special requests.
                </p>

                <a href="/contact" className="btn primary-btn">
                    Contact Us
                </a>
            </div>
            </>
        );
    }
}

export default Farming;
